const DASHBOARD_TYPES = {
  DEFAULT: 'default',
  DATA_DASHBOARD: 'data'
};

export { DASHBOARD_TYPES };
